import { $, addAction, INIT } from '@situation/setdesign.util';
import TriggeredAnimation from '../util/TriggeredAnimation';

addAction(INIT, () => {
    TriggeredAnimation.create($('.team-member-card'), 'team-member-card--show', {
        delay: 250,
        easing: 0,
    });
});
